import { render } from "./pay-failed.vue?vue&type=template&id=5a7a0f56&scoped=true&ts=true"
import script from "./pay-failed.vue?vue&type=script&lang=ts"
export * from "./pay-failed.vue?vue&type=script&lang=ts"

import "./pay-failed.vue?vue&type=style&index=0&id=5a7a0f56&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7a0f56"]])

export default __exports__